import { FieldError } from 'react-hook-form';
import { ErrorMessage } from './styles/ErrorComponent.styled';

export const ErrorComponent = ({ error }: { error: FieldError }) => {
  return error ? (
    <ErrorMessage className="error-message">{error.message}</ErrorMessage>
  ) : null;
};
